<script setup lang="ts">
import {computed} from "vue";
import type {ICellRendererParams} from "ag-grid-community";

const props = defineProps<{ params: ICellRendererParams & {rendererOptions?: any; colId?: string} }>();

function resolveColId(): string | undefined {
  return props.params.colId ?? props.params.column?.getColId();
}

const cell = computed(() => {
  const data: any = props.params.data;
  const colId = resolveColId();
  if (!data || !colId) return null;
  return data.cells?.[colId] ?? null;
});

const rendererOptions = computed(() => {
  const ctx = props.params.rendererOptions?.badge ?? {};
  return {
    shape: ctx.shape ?? 'pill',
    variant: ctx.variant ?? 'solid',
  };
});

const displayText = computed(() => cell.value?.displayValue ?? cell.value?.value ?? props.params.value ?? '');
const style = computed(() => cell.value?.style ?? {});
</script>

<template>
  <span v-if="displayText !== ''"
        class="bi-badge"
        :class="[
          rendererOptions.shape === 'square' ? 'bi-badge-square' : 'bi-badge-pill',
          rendererOptions.variant === 'outline' ? 'bi-badge-outline' : 'bi-badge-solid',
        ]"
        :style="{
          backgroundColor: rendererOptions.variant === 'outline' ? 'transparent' : (style.bg ?? '#e3f2fd'),
          color: style.color ?? (rendererOptions.variant === 'outline' ? (style.bg ?? '#1565c0') : '#0d47a1'),
          borderColor: style.bg ?? '#1565c0',
        }">
    {{ displayText }}
  </span>
</template>

<style scoped>
.bi-badge {
  display: inline-block;
  padding: 2px 10px;
  font-size: 0.85em;
  font-weight: 500;
  line-height: 1.4;
}
.bi-badge-pill {
  border-radius: 999px;
}
.bi-badge-square {
  border-radius: 4px;
}
.bi-badge-outline {
  border: 1px solid;
}
</style>
